<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Date-picker
              type="daterange"
              class="wid100P"
              @on-clear="resetDate"
              @on-change="getDateValue"
              :clearable="true"
              transfer
              format="yyyy-MM-dd"
              placement="bottom-end"
              :placeholder="$t('key1003837')"
              :options="dateOptions"
              :value="generateTime">
            </Date-picker>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" v-if="getPermission('ymsBill_exportCoreBill') ||
      getPermission('ymsBill_exportCoretailBill')">
        <Button type="primary">
          <span>{{ $t('key1003839') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="530"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1003838')"
      paramKeyColums="ymsCoreBillExportColumns"
      :customFieldExportList="customFieldExportList"
      :dimensionTypeList="dimensionTypeList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import ExportFieldsModal from "@/components/common/exportFieldsModal.vue";
import {commonLocalStorage, EventBus, pageJump} from "@/utils/common";

export default {
  name: 'platformBill',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      generateTime: [],
      pageParamsStatus: false,
      pageParams: {
        periodStartTime: null,
        periodEndTime: null,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'selection',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003612'),
          key: 'billNo',
          align: 'left',
          minWidth: 160,
          render(h, params) {
            return v.getPermission('ymsBill_coreBill') ? h('Alink', {
              props: {
                linkName: params.row.billNo
              },
              on: {
                AlinkBtn: () => {
                  v.detailBtn(params.row.ymsBillId)
                }
              }
            }) : h('span', params.row.billNo);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613'),
          key: 'billingCycle',
          minWidth: 200,
          align: 'left',
          render(h, params) {
            let periodStartTime = v.$uDate.getDateTime(params.row.periodStartTime);
            let periodEndTime = v.$uDate.getDateTime(params.row.periodEndTime);
            return h('span', `${periodStartTime} ~ ${periodEndTime}`);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000738'),
          key: 'currency',
          minWidth: 100,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003833'),
          key: 'totalProfit',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let price = v.formatCurrency(params.row.totalProfit);
            return h('span', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003834'),
          key: 'totalRevenue',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let price = v.formatCurrency(params.row.totalPrice);
            return h('span', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003835'),
          key: 'totalExpenditure',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let price = v.formatCurrency(params.row.totalExpenditureCost);
            return h('span', price);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003619'),
          key: 'updatedTime',
          minWidth: 170,
          align: 'left',
          render: (h, params) => {
            return h('div', v.$uDate.dealTime(params.row.updatedTime));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 120,
          render: function (h, params) {
            let ymsBillId = params.row.ymsBillId;
            let billStatus = params.row.billStatus; // 1 生成中 2 生成失败 3 生成成功
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000296'),
                    show: v.getPermission('ymsBill_coreBill'),
                    clickFn: () => {
                      v.detailBtn(ymsBillId)
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000337'),
                    show: billStatus !== 1 && v.getPermission('ymsBill_regenerateCoreBill'),
                    clickFn: () => {
                      v.updateBillBtn(ymsBillId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      selectTableData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003620'),
          titleKey: 'billingInfoColums',
          selectList: [],
          checkBoxList: [
            {type: [1, 2], paramKey: 'billNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003612')},
            {type: [1, 2], paramKey: 'billMonth', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613')},
            {type: [1, 2], paramKey: 'currency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000738')},
            {type: [1, 2], paramKey: 'totalProfit', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003833')},
            {type: [1, 2], paramKey: 'totalPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003834')},
            {type: [1, 2], paramKey: 'totalExpenditureCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003835')},
            {type: [1, 2], paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003619')}
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003610'),
          titleKey: 'rechargeRecordColums',
          selectList: [],
          checkBoxList: [
            {type: [2], paramKey: 'businessNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003598')},
            {type: [2], paramKey: 'businessType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003184')},
            {type: [2], paramKey: 'currency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000738')},
            {type: [2], paramKey: 'distributorMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877')},
            {type: [2], paramKey: 'orderAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599')},
            {type: [2], paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {type: [2], paramKey: 'productCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003600')},
            {type: [2], paramKey: 'packageProfit', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003601')}
          ]
        }
      ]
    }
  },
  computed: {
    dimensionTypeList() {
      let list = [
        {value: 1, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003644'), permissionKey: 'ymsBill_exportCoreBill'},
        {value: 2, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003645'), permissionKey: 'ymsBill_exportCoretailBill'}
      ];
      list.map((item) => {
        item['show'] = this.getPermission(item.permissionKey)
      });
      return list;
    }
  },
  mounted() {
    EventBus.$on('initPlatformBillUpdateCompletedData', this.handlePlatformBillData);
    let obj = commonLocalStorage.getItem('platformBillQuery');
    if (obj) {
      this.handlePlatformBillData(obj);
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 处理参数
    handlePlatformBillData(data) {
      this.$Modal.remove();
      if (data) {
        let periodStartTime = data.periodStartTime;
        let periodEndTime = data.periodEndTime;
        this.generateTime = [periodStartTime, periodEndTime];
        this.pageParams.periodStartTime = periodStartTime;
        this.pageParams.periodEndTime = periodEndTime;
        this.search();
      }
    },
    // 初始化接口数据
    initFun() {
      (async () => {
        await this.search();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.selectTableData = [];
      v.$refs['pageParams'].resetFields();
      v.resetDate();
      v.generateTime = [];
      v.getList();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.selectTableData = [];
      v.tableData = [];
      v.total = 0;
      v.$nextTick(() => {
        if (v.$refs['selection'] && v.$refs['selection'].selectAll) {
          v.$refs['selection'].selectAll(false);
        }
      });
      if (v.getPermission('ymsBill_queryForCoreBill')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsBill_queryForCoreBill, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            commonLocalStorage.removeItem('platformBillQuery');
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsBillId;
        });
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = Object.assign({}, v.pageParams);
      if (v.exportType === '1') {
        query.ymsBillIds = v.selectTableData
      } else {
        query.ymsBillIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          let dimensionType = data.dimensionType;
          let url = dimensionType === 1 ? api.post_ymsBill_exportCoreBill : api.post_ymsBill_exportCoretailBill;
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },
    // 获取统计时间
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.periodStartTime = null;
          v.pageParams.periodEndTime = null;
        } else {
          v.generateTime = value;
          v.pageParams.periodStartTime = v.$uDate.getUniversalTime(new Date(value[0]).getTime(), 'fulltime');
          v.pageParams.periodEndTime = v.$uDate.getUniversalTime(new Date(value[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置统计时间
    resetDate() {
      this.pageParams.periodStartTime = null;
      this.pageParams.periodEndTime = null;
    },
    // 查看详情
    detailBtn(ymsBillId) {
      this.$router.push({
        path: '/platformBillDetails',
        query: {
          ymsBillId: ymsBillId
        }
      });
    },
    // 更新账单
    updateBillBtn(ymsBillId) {
      let v = this;
      v.axios.post(api.post_ymsBill_regenerateCoreBill + ymsBillId).then(res => {
        if (res.data.code === 0) {
          v.$Modal.info({
            width: 550,
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003836'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003647'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
            onOk() {
              v.pageParamsStatus = true;
            }
          });
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('initPlatformBillUpdateCompletedData', this.handlePlatformBillData);
  },
  components: {
    ExportFieldsModal
  }
};
</script>

<style lang="less">

</style>
